<template>
  <tr class="tr-note" v-if="isShown">
    <td></td>
    <td :colspan="(shouldShowNote || shouldShowTime) ? 4 : 1">
      <span v-if="shouldShowNote">{{ note }}</span>
      <span v-if="shouldShowTime">
        {{ printDate(start, TIME_FORMAT) }} - {{ printDate(end, TIME_FORMAT) }}
      </span>
    </td>
    <td>
      <div class="text-right" v-if="shouldShowPromotion">{{ promotion }}</div>
    </td>
  </tr>
</template>
<script>
export default {
  name: 'BillItemNote',
  props: ['note', 'promotion', 'start', 'end', 'view'],
  data() {
    return {
      TIME_FORMAT: 'DD/MM HH:mm',
    };
  },
  computed: {
    isShown() {
      return this.shouldShowNote || this.shouldShowPromotion || this.shouldShowTime;
    },
    shouldShowNote() {
      return (this.note || this.shouldShowPromotion) && this.view === 'normal';
    },
    shouldShowPromotion() {
      return this.promotion && (this.view === 'normal' || this.view === 'modal');
    },
    shouldShowTime() {
      return (this.start || this.end) && (this.view === 'normal' || this.view === 'modal');
    },
  },
};
</script>
